import React, { useState } from "react";
import { Box, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import PlusIcon from "@icons/myicons/plus.svg?react";
import BankIcon from "@icons/myicons/bank.svg?react";
import { SettingsMenuItem } from "@features/settings/components/SettingsSidebar/SettingsMenuItem";
import { useBankConnections } from "@features/settings/SettingsBankConnections/useBankConnections";
import { ImportBankSelectModal } from "@features/bankSelect/ImportBankSelectModal";

const IconContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "18px",
  height: "18px",
  borderRadius: "4px",
  overflow: "hidden",

  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
}));

type Props = {};

export const BankConnections = (props: Props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const [isBankSelectOpen, setIsBankSelectOpen] = useState(false);

  const { finApiBankConnections, wealthApiBankConnections } =
    useBankConnections();
  const bankConnections = [
    ...finApiBankConnections,
    ...wealthApiBankConnections,
  ];

  return (
    <Box mt={7.5}>
      <Typography
        variant="overline"
        color="textSecondary"
        textTransform="uppercase"
        mb={1.5}
        ml={2}
      >
        {t("settings.sidebar.bankConnections.title")}
      </Typography>
      <Box display="flex" flexDirection="column" gap={0.5}>
        {bankConnections?.map((bankConnection) => (
          <SettingsMenuItem
            key={bankConnection.id}
            to={`/settings/bankConnections/${bankConnection.provider}/${bankConnection.id}`}
            title={bankConnection.name}
            hasNoAccounts={bankConnection?.hasNoAccounts}
            icon={
              <IconContainer>
                {bankConnection.iconUrl ? (
                  <img src={bankConnection.iconUrl} alt={bankConnection.name} />
                ) : (
                  <BankIcon />
                )}
              </IconContainer>
            }
            active={
              pathname ===
              `/settings/bankConnections/${bankConnection.provider}/${bankConnection.id}`
            }
          />
        ))}
        <SettingsMenuItem
          title={t("settings.sidebar.bankConnections.addNewConnection")}
          icon={
            <IconContainer>
              <PlusIcon width="11px" height="11px" />
            </IconContainer>
          }
          onClick={() => setIsBankSelectOpen(true)}
          active={false}
          secondary
        />
      </Box>
      {isBankSelectOpen && (
        <ImportBankSelectModal onClose={() => setIsBankSelectOpen(false)} />
      )}
    </Box>
  );
};
